import Icons from '../styles/Icons'
import { HelpOutlineRounded } from '@mui/icons-material';

export const customerPages = [
  {
    title: "Start",
    route: "/"
  },
  {
    title: "Tjänster",
    route: "/services"
  },
  {
    title: "FAQ",
    route: "/faq"
  },
  {
    title: "Kontakt",
    route: "/contact"
  }
];

export const employeePages = [
  {
    title: "Dashboard",
    route: "/dashboard",
    icon: <Icons.DashboardIcon />
  },
  {
    title: "Kundregister",
    route: "/customers",
    icon: <Icons.CustomersIcon />
  },
  {
    title: "Orderstatus",
    route: "/orders",
    icon: <Icons.OrdersIcon />
  },
  {
    title: "FAQ",
    route: "/faq",
    icon: <Icons.FaqIcon />
  },
  {
    title: "Hjälp",
    route: "/help",
    icon: <HelpOutlineRounded />
  }
];



export const adminPages = [
  {
    title: "Erbjudanden",
    route: "/offers",
    icon: <Icons.OffersIcon />
  },
  {
    title: "Utskick",
    route: "/mailings",
    icon: <Icons.MailingIcon />
  },
  {
    title: "Inställningar",
    route: "/settings",
    icon: <Icons.SettingsIcon />
  }
];